import React, { useEffect, useState } from "react";
import { AxiosResponse, AxiosError } from "axios";
import { Result, IcdGr } from "../../interface/ICD";
import { IcdAxiosInstance } from "../../Network/IcdAxiosInstance";
import ListOfCustomIcds from "../Shared/ListOfIcds";
import { Option } from "../../interface/Option";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ListOfCustomIcdGroups from "../Shared/ListOIcdGroupingname";
import { ColumnDef } from "@tanstack/react-table";
import { DataTable } from "shared/DataTable";
import { Button } from "../../components/ui/button";

const IcdGrouping: React.FC = () => {
  const [items, setItems] = useState<IcdGr>({ result: [] });
  const [GroupName, setGroupName] = useState<string>("");
  const [medicalIcdGroups, setmedicalIcdGroups] = useState<string[]>([]);
  const token = localStorage.getItem("token") || "";
  const [editIndex, setEditIndex] = useState<null | number>(null);
  const [selectedIcds, setSelectedIcds] = useState<Option[]>([]);
  const [selectedCustomIcdGroups, setSelectedCustomIcdGroups] = useState<
    Option[]
  >([]);
  const [GroupNameError, setGroupNameError] = useState<string>("");
  const [GroupNameisValid, setGroupNameIsValid] = useState<boolean>(true);
  const [selectedIcdsisValid, setselectedIcdsIsValid] = useState<boolean>(true);
  const [selectedIcdsError, setselectedIcdsError] = useState<string>("");
  const [clearListOfICDS, setClearListOfICDS] = useState(false);
  const [clearSelectedCustomIcdGroups, setClearSelectedCustomIcdGroups] =
    useState(false);
  const [reloadTrigger, setReloadTrigger] = useState(false);

  useEffect(() => {
    fetchItems();
  }, []);

  useEffect(() => {
    if (clearListOfICDS || clearSelectedCustomIcdGroups) {
      setClearListOfICDS(false);
      setClearSelectedCustomIcdGroups(false);

      // clear select option for ListOfICDS
    }
  }, [clearListOfICDS, clearSelectedCustomIcdGroups]);
  const clear = () => {
    setGroupName("");
    setSelectedIcds([]);
    setSelectedCustomIcdGroups([]);
    setmedicalIcdGroups([]);
    setClearSelectedCustomIcdGroups(true);

    setClearListOfICDS(true);
  };

  //When adding or deleting a new group, it appears or disappears directly from custom ICDS
  const handleAddOrDeleteGroup = () => {
    setReloadTrigger(!reloadTrigger);
  };
  const handleIcdsChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setSelectedIcds(selectedOptions);
  };
  const handleCustomIcdsGroupsChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setSelectedCustomIcdGroups(selectedOptions);
  };
  const handleGroupNameBlur = (): void => {
    if (!GroupName.trim()) {
      setGroupNameError("Group Name is required");
      setGroupNameIsValid(false);
    } else {
      setGroupNameError("");
      setGroupNameIsValid(true);
    }
  };
  const GroupNamevalidate = (): boolean => {
    if (!GroupName.trim()) {
      setGroupNameError("Group Name is required");
      setGroupNameIsValid(false);

      return false;
    }
    setGroupNameError("");
    setGroupNameIsValid(true);

    return true;
  };
  const listOfICDSvalidate = (): boolean => {
    if (!selectedIcds || selectedIcds.length === 0) {
      setGroupNameError("list Of ICDS is required");
      setGroupNameIsValid(false);
      return false;
    }

    setGroupNameError("");
    setGroupNameIsValid(true);

    return true;
  };
  const handleListOfICDSBlur = (): void => {
    if (!selectedIcds || selectedIcds.length === 0) {
      setselectedIcdsError("list Of ICDS are required");
      setselectedIcdsIsValid(false);
    } else {
      setselectedIcdsError("");
      setselectedIcdsIsValid(true);
    }
  };

  const validateGroupName = (name: string) => {
    if (name.trim()) {
      setGroupNameError("");
      setGroupNameIsValid(true);
    } else {
      setGroupNameError("Group Name is required.");
      setGroupNameIsValid(false);
    }
  };
  const handleGroupNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setGroupName(value);
    // Check as you type
    validateGroupName(value);
  };
  const fetchItems = async (): Promise<void> => {
    try {
      const response: AxiosResponse<{ success: boolean; result: Result[] }> =
        await IcdAxiosInstance.get("geticd");
      setItems({ result: [...response.data.result].sort((a: any, b: any) => b.id - a.id) });

      console.log(response.data.result);
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };

  // ..............................additem..................................
  const addItem = async (): Promise<void> => {
    const ICDS = selectedIcds.map((option) => option.value);
    const CustomIcdsGroups = selectedCustomIcdGroups.map(
      (option) => option.value
    );
    const isFormValid = GroupNamevalidate();
    const isForm2Valid = listOfICDSvalidate();

    if (!isFormValid || !isForm2Valid) {
      return;
    }

    try {
      const newGroup = {
        custom_group_name: GroupName,
        icds: ICDS,
        custom_icd_groups: CustomIcdsGroups,
        medical_icd_groups: medicalIcdGroups,
        token: token,
      };

      const response = await IcdAxiosInstance.post("add", newGroup);

      if (response.data.success) {
        fetchItems();
        clear();
        handleAddOrDeleteGroup();
        setGroupNameIsValid(true);
        setselectedIcdsIsValid(true);
        toast.success("New Group Added Successfully.");
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        console.error("Error adding item:", error);
        setGroupNameIsValid(false);

        toast.error(`${error.response.data.error}`);
      } else {
        // If there is another error unrelated to the response such as a connection interruption
        toast.error("An unexpected error occurred.");
      }
    }
  };

  const handleEdit =  (item: Result) => {
    setGroupName(item.custom_group_name);
    const ICDS = (item.icds || []).map((icd: string) => ({
      label: icd,
      value: icd,
    }));
    setSelectedIcds(ICDS);
    const CustomIcdsGroups = (item.custom_icd_groups || []).map(
      (custom_icd_group: number) => ({
        label: String(custom_icd_group),
        value: custom_icd_group,
      })
    );
    setSelectedCustomIcdGroups(CustomIcdsGroups);
    setmedicalIcdGroups(item.medical_icd_groups);
    setEditIndex(item.id);
  }

  const removeItem = async (id: string | number): Promise<void> => {
    try {
      await IcdAxiosInstance.delete(`delete/${id}`, {
        data: { token: token },
      });
      handleAddOrDeleteGroup();
      fetchItems();
    } catch (error) {
      console.error("Error removing item:", error);
    }
  };
  //...................................... updateItem................................
  const updateItem = async (id: string | number): Promise<void> => {
    const isFormValid = GroupNamevalidate();

    if (!isFormValid) {
      return;
    }
    try {
      const ICDS = selectedIcds.map((option) => option.value);
      const CustomIcdsGroups = selectedCustomIcdGroups.map(
        (option) => option.value
      );

      const updatedItem = {
        custom_group_name: GroupName,
        icds: ICDS,
        custom_icd_groups: CustomIcdsGroups,
        medical_icd_groups: medicalIcdGroups,
        id: id,
        token: token,
      };

      const response = await IcdAxiosInstance.put(`update`, updatedItem);

      if (response.data.success) {
        fetchItems();
        clear();
        handleAddOrDeleteGroup();
        setGroupNameIsValid(true);
        setselectedIcdsIsValid(true);
        toast.success("New Group update successfully.");
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        console.error("Error adding item:", error);

        toast.error(`${error.response.data.error}`);
      } else {
        // If there is another error unrelated to the response such as a connection interruption
        toast.error("An unexpected error occurred.");
      }
    }
  };

  const columns: ColumnDef<Result>[] = [
    {
      accessorKey: "id",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          ID
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },
    {
      accessorKey: "custom_group_name",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Group Name
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },
    {
      accessorKey: "icds",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          List of ICD
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const icds = row.getValue("icds") as string[];
        return Array.isArray(icds) ? icds.join(", ") : icds;
      },
    },
    {
      accessorKey: "custom_icd_groups",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Custom ICD Groups
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const groups = row.getValue("custom_icd_groups") as string[];
        return Array.isArray(groups) ? groups.join(", ") : groups;
      },
    },
    {
      accessorKey: "medical_icd_groups",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Medical ICD Groups
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const groups = row.getValue("medical_icd_groups") as string[];
        return Array.isArray(groups) ? groups.join(", ") : groups;
      },
    },
    
  ];

  // const columns: Column<Result>[] = [
  //   { header: "ID", accessor: "id" },
  //   { header: "GroupName", accessor: "custom_group_name" },
  //   {
  //     header: "List of ICDS",
  //     accessor: "icds",
  //     Cell: ({ value }) => (Array.isArray(value) ? value.join(", ") : value),
  //   },

  //   {
  //     header: "Custom ICD Groups",
  //     accessor: "custom_icd_groups",
  //     Cell: ({ value}) => (Array.isArray(value) ? value.join(", ") : value),
  //   },
  //   {
  //     header: "Medical ICD Groups",
  //     accessor: "medical_icd_groups",
  //     Cell: ({ value }) => (Array.isArray(value) ? value.join(", ") : value),
  //   },
  // ];

  return (
    <div className="container mx-auto p-8">
      <h5 className="mb-6 flex items-center gap-2">
        ICD Grouping Screen
        <i className="fa-solid fa-briefcase"></i>
      </h5>

      {/* <div className="mb-8 rounded-lg shadow-lg p-6 flex flex-col md:flex-row justify-between items-center">
        <div className="mb-4 md:mb-0">
          <button
            id="add_button"
            className="btn btn-success"
            data-bs-toggle="modal"
            data-bs-target="#exampleModal"
          >
            Add New ICD Group
          </button>
        </div>

        <div className="flex flex-col items-center gap-2">
          <input
            type="text"
            className="form-control text-center w-full md:w-1/2"
            placeholder="Search..."
          />
          <button className="btn btn-success w-full md:w-1/4">Search</button>
        </div>
      </div> */}

      {/* Table */}
      {/* <Table<Result>
        data={items.result}
        columns={columns}

        onEdit={(item) => {
          setGroupName(item.custom_group_name);
          const ICDS = (item.icds|| []).map((icd: string) => ({
            label: icd,
            value: icd,
          }));
      setSelectedIcds(ICDS)
         const CustomIcdsGroups = (item.custom_icd_groups || []).map((custom_icd_group: number) => ({
          label: String(custom_icd_group),
          value: custom_icd_group,          
        }));
    
        setSelectedCustomIcdGroups(CustomIcdsGroups);
          setmedicalIcdGroups(item.medical_icd_groups);
          setEditIndex(item.id);
        }}
        onDelete={removeItem}
      /> */}

      <DataTable
        columns={columns}
        data={items.result}
        searchColumn="custom_group_name"
        addButtonLabel="Add ICD Group" // Custom button text
        modalId="exampleModal" // Custom add modal ID
        showAddButton={true} // Control visibility
        onEdit={handleEdit}
        onDelete={removeItem}
      />

      <div
        className="modal fade"
        id="exampleModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Add Item
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={(e) => {
                  setEditIndex(null);
                  clear();
                  setGroupNameIsValid(true);
                  setselectedIcdsIsValid(true);
                  setGroupNameError("");
                  setselectedIcdsError("");
                  handleAddOrDeleteGroup();
                }}
              >
                {" "}
              </button>
            </div>

            <div className=" container d-flex flex-column align-items-center ">
              <div style={{ margin: "15px", width: "80%" }}>
                <div style={{ marginBottom: "10px" }}>
                  <label className="m-2">Group Name</label>
                  <input
                    type="text"
                    className="form-control"
                    style={{
                      marginBottom: "7px",
                      borderColor: !GroupNameisValid ? "red" : "",
                      transition: "border-color 0.3s",
                    }}
                    value={GroupName}
                    // Check as you type
                    onChange={handleGroupNameChange}
                    // Check when exiting input

                    onBlur={handleGroupNameBlur}
                  />
                  {GroupNameError && (
                    <div style={{ color: "red" }}>{GroupNameError}</div>
                  )}
                </div>

                <div style={{ marginTop: "10px", width: "500PX" }}>
                  <label className="form-label">List of ICD:</label>
                  <div onBlur={handleListOfICDSBlur}>
                    <ListOfCustomIcds
                      onChange={handleIcdsChange}
                      clear={clearListOfICDS}
                      defaultValue={selectedIcds}
                    />
                  </div>

                  {selectedIcdsError && (
                    <div style={{ color: "red" }}>{selectedIcdsError}</div>
                  )}
                </div>

                <div style={{ marginBottom: "10px", width: "500PX" }}>
                  <label className="form-label">List Of Custom Groups:</label>
                  <ListOfCustomIcdGroups
                    reloadTrigger={reloadTrigger}
                    onChange={handleCustomIcdsGroupsChange}
                    clear={clearListOfICDS}
                    defaultValue={selectedCustomIcdGroups}
                  />
                </div>

                <div style={{ marginBottom: "10px" }}>
                  <label className="form-label">List Of Medical Groups:</label>
                  <input
                    type="text"
                    className="form-control"
                    value={medicalIcdGroups.join(",")}
                    onChange={(e) => setmedicalIcdGroups([e.target.value])}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={
                  editIndex === null ? addItem : () => updateItem(editIndex)
                }
                disabled={!GroupNameisValid || !selectedIcdsisValid}
              >
                {editIndex === null ? "Add Item" : "Update Item"}
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={(e) => {
                  setEditIndex(null);
                  clear();
                  setGroupNameIsValid(true);
                  setselectedIcdsIsValid(true);
                  setGroupNameError("");
                  setselectedIcdsError("");
                  handleAddOrDeleteGroup();
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

export default IcdGrouping;
